import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { DeviceMobile, X } from "@phosphor-icons/react";

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem("pwa_install_dismissed") === "true";
  });

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  // Check if already installed
  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches) {
      setDismissed(true);
    }
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem("pwa_install_dismissed", "true");
  };

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      handleDismiss();
    }
    setDeferredPrompt(null);
  };

  if (dismissed || !deferredPrompt) return null;

  return (
    <div
      data-testid="install-prompt"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 z-50 bg-white border border-slate-200 rounded-xl shadow-xl p-4 flex items-start gap-3"
    >
      <div className="w-10 h-10 rounded-lg bg-[#B8860B] flex items-center justify-center shrink-0">
        <DeviceMobile size={22} weight="duotone" className="text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-[#1A1A1A]" style={{ fontFamily: "Work Sans" }}>
          Install P3UW
        </p>
        <p className="text-xs text-slate-500 mt-0.5">
          Akses cepat & offline dari layar utama HP Anda
        </p>
        <div className="flex items-center gap-2 mt-2.5">
          <Button
            data-testid="install-btn"
            size="sm"
            onClick={handleInstall}
            className="h-7 text-xs bg-[#B8860B] hover:bg-[#9A7209] text-white"
          >
            Install
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleDismiss}
            className="h-7 text-xs text-slate-400"
          >
            Nanti
          </Button>
        </div>
      </div>
      <button
        onClick={handleDismiss}
        className="text-slate-300 hover:text-slate-500 shrink-0"
      >
        <X size={16} />
      </button>
    </div>
  );
}
